var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBriefcaseIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 67.308 62",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".briefcase_icon_svg__a{fill:none;stroke:inherit;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.231 1)",
    "data-svg-primary": "stroke"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "briefcase_icon_svg__a",
    width: 64.884,
    height: 47.375,
    rx: 10.09,
    transform: "translate(0 12.625)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "briefcase_icon_svg__a",
    d: "M25.672 0h13.541c3.246 0 5.878 3.01 5.878 6.723v5.909H19.794V6.723C19.794 3.01 22.426 0 25.672 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "briefcase_icon_svg__a",
    d: "M38.924 12.562H25.966V8.527a2.086 2.086 0 011.933-2.211h9.087a1.817 1.817 0 011.371.645 2.381 2.381 0 01.568 1.566zM37.998 33.467l26.85-7.425M0 26.042l26.825 7.425"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "briefcase_icon_svg__a",
    width: 10.584,
    height: 7.726,
    rx: 2.42,
    transform: "translate(27.15 29.586)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBriefcaseIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/briefcase_icon.a9000c41d42bfe9261631ce0c18219a4.svg";